import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ProductImage from '../ProductImage/ProductImage'
import getProductPageUrl from '../../helpers/getProductPageUrl'

import * as Styled from './Bundle.styles'
import { generateUrlParameters } from '../../helpers/recommendationsAnalytics'

class BundleItem extends PureComponent {
  render() {
    const { item, currentProduct } = this.props
    const { id, name } = item
    const imgDimensions = { height: 75, width: 75 }
    const titleClass = 'bundle__title'
    const containerClass = 'bundle__item xs-6--none sm-3--none'

    return (
      <BundleItemContainer {...{ id, currentProduct }} className={containerClass}>
        <ProductImage partNumber={id} {...imgDimensions} />
        <BundleItemTitle className={titleClass} text={name} />
      </BundleItemContainer>
    )
  }
}

BundleItem.propTypes = {
  item: PropTypes.object.isRequired,
  currentProduct: PropTypes.string.isRequired
}

const BundleItemContainer = props => {
  const { className, children, currentProduct, id } = props
  const isCurrentProduct = currentProduct === id
  const url = getProductPageUrl(id)

  const parameters = generateUrlParameters({
    fromProduct: currentProduct,
    toProduct: id,
    sectionPlacement: 'fbtComponent',
    innerPlacement: 'P1',
    sectionTitle: 'FBT',
    strategy: 'bundles'
  })

  const anchor = (
    <Styled.Anchor className={className} href={url + parameters}>
      {children}
    </Styled.Anchor>
  )
  const div = <Styled.Div className={className}>{children}</Styled.Div>
  return isCurrentProduct ? div : anchor
}

const BundleItemTitle = ({ text, className }) => <span className={className}>{text}</span>

export default BundleItem
export { BundleItemContainer, BundleItemTitle }
